import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, DUCK_LOGO, formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setRes(data);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="w-full max-w-md p-8 rounded-2xl cq-in" data-testid="forgot-card">
        <Link to="/" data-testid="fp-brand-home" aria-label="Back to home"><img src={DUCK_LOGO} alt="" className="h-14 w-14 object-contain hover:scale-105 transition" /></Link>
        <h1 className="font-display text-3xl font-black mt-4">Forgot password</h1>
        <p className="text-slate-500 mt-1 text-sm">Enter your email — we'll send a reset link.</p>

        {!res ? (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" /></div>
            {err && <p className="text-sm text-red-600" data-testid="forgot-error">{err}</p>}
            <Button type="submit" disabled={busy} className="w-full bg-amber-500 hover:bg-amber-600 h-11 rounded-xl" data-testid="forgot-submit">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        ) : (
          <div className="mt-6 rounded-xl bg-amber-50 border border-amber-100 p-4 text-sm" data-testid="forgot-success">
            <p className="font-semibold text-slate-800">{res.message}</p>
            {res.dev_reset_link && (
              <>
                <p className="text-xs text-slate-500 mt-2">Emails aren't fully live yet (Resend domain pending). Use this reset link directly:</p>
                <a href={res.dev_reset_link} className="mt-2 inline-block break-all text-sky-700 underline text-xs font-semibold" data-testid="dev-reset-link">{res.dev_reset_link}</a>
              </>
            )}
          </div>
        )}
        <p className="mt-6 text-sm text-slate-500"><Link to="/login" className="text-amber-600 font-bold">Back to sign in</Link></p>
      </Card>
    </div>
  );
}
